// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bzali{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-ecqav{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-pikmh{grid-column:span 6}.assets-scss-gridstyleGrid-col3-cbset{grid-column:span 3}.assets-scss-gridstyleGrid-col4-blbyw{grid-column:span 4}.assets-scss-gridstyleGrid-col9-binpu{grid-column:span 9}.assets-scss-gridstyleGrid-col12-yrtfx{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-brseb{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bzali",
	"grid": "assets-scss-gridstyleGrid-grid-ecqav",
	"col6": "assets-scss-gridstyleGrid-col6-pikmh",
	"col3": "assets-scss-gridstyleGrid-col3-cbset",
	"col4": "assets-scss-gridstyleGrid-col4-blbyw",
	"col9": "assets-scss-gridstyleGrid-col9-binpu",
	"col12": "assets-scss-gridstyleGrid-col12-yrtfx",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-brseb"
};
module.exports = ___CSS_LOADER_EXPORT___;
